import { Component } from '@angular/core';
import { Routes } from '@angular/router';

import { BaMenuService } from '../theme';
import { PAGES_MENU } from './pages.menu';
import { settings } from 'cluster';
import { AuthService } from '../common/services/permission';
import { MasterRepo } from '../common/repositories';
import { CommonService } from '../common/services/common.service';

@Component({
  selector: 'pages',
  template: `
    <ba-sidebar></ba-sidebar>
    <ba-page-top></ba-page-top>
    <div class="al-main">
      <div class="al-content">
        <ba-content-top></ba-content-top>
        <router-outlet></router-outlet>
      </div>
    </div>
    <footer class="al-footer clearfix">
      <div class="al-footer-right">Created with <i class="ion-heart"></i></div>
      <div class="al-footer-main clearfix">
        <div class="al-copy">&copy; <a href="http://www.imssoftware.com.np/" target="_blank">IMS Software Pvt. Ltd.</a> {{currentYear}}</div>
        <ul class="al-share clearfix">
          <li><a  href="https://www.facebook.com/imssoftwarenepal"  target="_blank"><i class="socicon socicon-facebook"></i></a></li>

        </ul>
      </div>
    </footer>
    <ba-back-top position="200"></ba-back-top>
    `
})
export class Pages {
  private currentYear;
  constructor(private _menuService: BaMenuService, private _authService:AuthService, private masterService:MasterRepo, private common:CommonService) {   
  }

  ngOnInit() {
    
    this.common.recursiveForEach(PAGES_MENU,(item)=>{ 
      if(item.data && item.data.menu) {
        var menuRight = this._authService.getRole.menuRights.find(x=>x.menuId === item.path);
        if(menuRight)
          item.data.menu.hidden = menuRight.hidden;
        else 
          item.data.menu.hidden = true;
      }
    });
    this._menuService.updateMenuByRoutes(<Routes>PAGES_MENU);
    var date  = new Date();
    this.currentYear = date.getFullYear();
  }

  
}
